// import { useQuery } from "@tanstack/react-query";

import { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useProducto } from "../../actions/Producto";
import { GotoLogin } from "../../actions/renovarLog";

import { Pencil, SquareX, CirclePlus } from "lucide-react";
import style from "../../styles/grid.module.css";
const Productos = () => {
   const navigate = useNavigate();
   const [nombre, setName] = useState(localStorage.getItem("filtroProducto") || "");
   const { GetProductos,deleteProductos } = useProducto();
   
   useEffect(() => {
      localStorage.setItem("filtroProducto", nombre);
   }, [nombre]);

   var data = GetProductos();

   function handleInputChange(e) {
      if (e.key === "Enter") {
         console.log("nombre: ", nombre);
         setName("nombre");
      }
   }

   const handleRemove = async (id) => {
      console.log('id: ', id);
      let text =
         "Se va a eliminar el Producto selecionado!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         await deleteProductos.mutateAsync(id);
         navigate("/productotattoo");
      }
   };
   const numberFormat = new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   });   
   
   if (data?.message === "Token inválido") {
      return <GotoLogin />;
   }
   // console.log('data: ', data);
   
   return (
      <>
         <div className={style.tableCli}>
            <div className={style.header}>
               <div className={style.gridTitle}>
                  <h2>Catalogo de Tattoo</h2>
               </div>
               <div className={style.divBuscar}>
                  <label htmlFor="search-navbar" className={style.lblBuscar}>&nbsp;Filtrar:&nbsp;</label>
                  <input
                     className={style.inputBuscar}
                     onKeyPress={(e) => handleInputChange(e)}
                     onChange={(e) => setName(e.target.value)}
                     type="text"
                     id="search-navbar"
                     placeholder="Buscar..."
                     value={nombre}
                  />
               </div>
               <div>
                  <Link
                     to={"/formProductotattoo"}
                     className="dLink"
                     title="Alta Producto"
                     state={{
                        id_primary: 0,
                        id: 0,
                        companyId: 0,
                        descripcion: "",
                        dolar: 0,
                        cod_status: 1,
                        size: 0,
                        gauge: 0, 
                        esteril:0,            
                        tipoprod:3,           
                        cod_proveedor: "",
                        stock: 0,
                     }}
                  >
                     {"     "}
                     <CirclePlus className="lucidePlus" />
                     {/* <button className={style.inputBtnServ}>Nuevo Producto</button>                      */}
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
            <div>
               <table className={style.gridTable}>
                  <thead>
                     <tr>
                        {/* <th className={style.style_titulos}>Codigo</th> */}
                        <th>Descripcion</th>
                        <th className={style.style_titulos}>Precio</th>
                        <th className={style.style_titulos}>Stock</th>
                        <th>+Info</th>
                     </tr>
                  </thead>
                  <tbody>
                     {data &&
                        data?.map((prod) => {
                              var muestroreg=true
                              if (isNaN(nombre)){
                                 if (nombre!==""){
                                    if (prod.descripcion.toUpperCase().includes(nombre.toUpperCase())){
                                       muestroreg=true
                                    } else {
                                       muestroreg=false
                                    }
                                 }

                              }else {
                                 // busca por código de proveedor
                                    if (prod.cod_proveedor.includes(nombre)){
                                       muestroreg=true
                                    } else {
                                       muestroreg=false
                                    }
                                 
                              }
                              // Solo muestro productos de tattoo
                              if (parseInt(prod.tipoprod) !== 3) {
                                 muestroreg = false;
                              }
                              if (muestroreg)
                              {

                                 return (
                                    <tr key={prod.id} 
                                    className={parseInt(prod.cod_status)===2 ? style.trdatosRed : style.trdatos}
                                    >
                                    {/* <td className={style.style_td}>
                                       {prod.cod_proveedor}
                                    </td> */}
                                    <td className={style.style_td}>{prod.descripcion}</td>
                                    <td className={style.style_precio}>
                                       $&nbsp;{numberFormat.format(prod.dolar)}&nbsp;&nbsp;&nbsp;
                                    </td>
                                    <td className={style.style_precio}>
                                       {prod.stock}&nbsp;&nbsp;
                                    </td>
                                    <td>
                                       <Link
                                          title="Editar Producto"
                                          to={"/formProductotattoo"}
                                         
                                          state={{
                                             id_primary: prod.id_primary,
                                             id: prod.id,
                                             companyId: prod.companyId,
                                             descripcion: prod.descripcion,
                                             dolar: prod.dolar,
                                             stock: prod.stock,
                                             size: prod.size,
                                             gauge: prod.gauge,
                                             esteril:prod.esteril,
                                             cod_proveedor: prod.cod_proveedor,
                                             tipoprod:3,
                                             cod_status: prod.cod_status,
                                          }}
                                       >
                                       <Pencil />
                                         </Link>
                                       &nbsp;&nbsp;
                                       <span
                                       title="Eliminar Producto"
                                       className="lucideIconDel"
                                       onClick={() => handleRemove(prod.id)}
                                       >
                                       <SquareX />
                                    </span>
                                    </td>
                                 </tr>
                              );
                           } else {
                              return (null)
                           }
                        })}
                  </tbody>
               </table>
            </div>
            <br />
         </div>
      </>
   );
};

export default Productos;
